function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
// Limitless imports
import { createSuggestions, convertSuggestionsToLabelArray } from "../../../../utils/AutoCompleteDataUtil";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import AiReasoningStarIcon from "../ai-reasoning-star-icon/AiReasoningStarIcon";
class CategoriseByTags extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleTagListChange", (newTagList, isMandatory) => {
      const {
        onValueChange,
        action
      } = this.props;
      this.setState({
        selectedTags: newTagList
      });
      const newValue = {
        value: newTagList,
        doLiveUpdate: !isMandatory ? true : newTagList.length > 0,
        isStepComplete: true
      };
      if (newTagList.length === 0) {
        newValue.isStepComplete = false;
        newValue.value = [];
      }
      onValueChange({
        [action.payloadKey]: newValue
      });
    });
    const {
      message,
      value
    } = this.props;
    let selectedTags = value.value;

    //pre-populated the currently selected tags if they already exists on the message
    if (value.value.length === 0) {
      selectedTags = message.editableTags;
    }
    this.state = {
      selectedTags
    };
  }
  componentDidUpdate(prevProps) {
    var _aiReviewData$respond, _aiReviewData$respond2, _prevProps$aiReviewDa, _prevProps$aiReviewDa2, _prevProps$aiReviewDa3;
    const {
      aiReviewData,
      messageResources,
      value
    } = this.props;
    const aiTagString = aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond = aiReviewData.respondTags) === null || _aiReviewData$respond === void 0 ? void 0 : (_aiReviewData$respond2 = _aiReviewData$respond.tags) === null || _aiReviewData$respond2 === void 0 ? void 0 : _aiReviewData$respond2.trim();
    const prevAiTagString = (_prevProps$aiReviewDa = prevProps.aiReviewData) === null || _prevProps$aiReviewDa === void 0 ? void 0 : (_prevProps$aiReviewDa2 = _prevProps$aiReviewDa.respondTags) === null || _prevProps$aiReviewDa2 === void 0 ? void 0 : (_prevProps$aiReviewDa3 = _prevProps$aiReviewDa2.tags) === null || _prevProps$aiReviewDa3 === void 0 ? void 0 : _prevProps$aiReviewDa3.trim();

    // Only update if new AI tags arrive, and current selection is empty
    if (aiTagString && aiTagString !== prevAiTagString) {
      const aiTagsArray = aiTagString.split(",").map(tag => tag.trim().toUpperCase());
      const allSuggestions = createSuggestions(messageResources.tags, {
        labelDataKey: "labelText"
      });
      const matchedTags = allSuggestions.filter(suggestion => aiTagsArray.includes(suggestion.value.toUpperCase())).map(tag => tag.value);
      this.handleTagListChange(matchedTags, this.props.isMandatory);
    }
  }
  render() {
    var _aiReviewData$respond3;
    const {
      messageResources,
      action,
      isMandatory,
      isReadOnly,
      aiReviewData
    } = this.props;
    const {
      selectedTags
    } = this.state;
    const suggestions = createSuggestions(messageResources.tags, {
      labelDataKey: "labelText"
    });
    const aiClassificationReasoning = aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond3 = aiReviewData.respondTags) === null || _aiReviewData$respond3 === void 0 ? void 0 : _aiReviewData$respond3.reasoning;
    return /*#__PURE__*/React.createElement(DropdownMenu, {
      label: /*#__PURE__*/React.createElement(React.Fragment, null, action.title, aiClassificationReasoning && /*#__PURE__*/React.createElement(AiReasoningStarIcon, {
        title: aiReviewData.respondTags.reasoning
      })),
      required: isMandatory,
      multiple: true,
      sx: {
        "& .MuiOutlinedInput-root": {
          height: "auto"
        }
      },
      value: createSuggestions(selectedTags),
      id: "tagsAutocomplete",
      fullWidth: true,
      disableCloseOnSelect: true,
      isOptionEqualToValue: (option, value) => option.value === value.value,
      options: suggestions,
      placeholder: "Type to search tags",
      onChange: (e, values) => this.handleTagListChange(convertSuggestionsToLabelArray(values)),
      disabled: isReadOnly
    });
  }
}
export default CategoriseByTags;
CategoriseByTags.propTypes = {
  action: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  messageResources: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  isMandatory: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  aiReviewData: PropTypes.object
};